
const state = {
  netWorkError : "",
  netWorkCode : "",
  showDialog :false,
}

export default state
